/* eslint-disable react/jsx-indent */
/* eslint-disable */
import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import PropTypes from 'prop-types';
// import { getJson } from 'session';
import { ModalContext } from 'App';
// import { Acl } from 'modules/common/components/Acl'
// import ConfirmLabTest from 'modules/common/components/ConfirmLabTest';
// import ConfirmAlert from 'modules/common/components/ConfirmAlert';
// import ConfirmAlertWithAmount from 'modules/common/components/ConfirmAlertWithAmount';
import ProfileInformation from './ProfileInformation';

import VerifyReceipt from './VerifyReceipt';

import * as action from '../action';
import * as c from '../constant';
// import UpdateAppointmentModal from '../components/UpdateAppointmentModal';

function SeniorCitizenContent({
  match,
  isLoading,
  permissions,

  showSeniorCitizentList,
  clearSeniorCitizen,
  seniorCitizenInfo,

  approveTransaction,
  rejectTransaction,

  // transactionInfo,
  onApprove,
  onReject,
}) {
  const setModal = useContext(ModalContext);
  const selectedSeniorCitizen = match.params.id;
  // const [formData, setFormData] = useState({})

  // const verifyTransaction = status => {
  //   return ['AMOUNT'].includes(
  //     status
  //   );
  // };

  const viewApproveReject = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <VerifyReceipt
          // onApprove={onApprove}
          // onReject={onReject}
          seniorCitizenInfo={seniorCitizenInfo}
          id={selectedSeniorCitizen}
        />
      ),
      title: `Approve / Reject`,
      modalSize: 'modal-md',
    });
  };

  const handleOnCHange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  }

  // const handleApprove = (e) => {
  //   e.preventDefault();

  //   ConfirmAlertWithAmount(
  //     'Are you sure you want to approve this transaction?',
  //     (remarks, amount) => {
  //       approveTransaction(
  //         selectedSeniorCitizen,
  //         {
  //           remarks,
  //           amount,
  //           module_type: 'SENIOR',
  //         },
  //         () => {
  //           showTransaction(selectedSeniorCitizen); 
  //         }
  //       );
  //     },
  //     () => {
  //       FormData
  //     },
  //     {
  //       yesLabel: 'Confirm',
  //       noLabel: 'Cancel',
  //     },
  //     true
  //   );
  // };

  // const handleReject = (e) => {
  //   e.preventDefault();
  //   ConfirmAlert(
  //     'Are you sure, you want to Reject this application',
  //     (remarks) => {
  //       rejectTransaction(
  //         selectedSeniorCitizen,
  //         {
  //           remarks,
  //           status: 'REJECTED',
  //           module_type: 'SENIOR',
  //         },
  //         () => {
  //           showTransaction(selectedSeniorCitizen);
  //         }
  //       );
  //     },
  //     () => {},
  //     {
  //       yesLabel: 'Confirm',
  //       noLabel: 'Cancel',
  //     },
  //     true
  //   );
  // };

  const updateData = () => {
    showSeniorCitizentList(selectedSeniorCitizen);
  };

  useEffect(() => {
    if (!_.isEmpty(selectedSeniorCitizen)) {
      updateData();
    }
    return () => {
      clearSeniorCitizen();
    };
  }, []);

  useEffect(() => {
    if (!_.isEmpty(selectedSeniorCitizen)) {
      updateData();
    }
  }, [selectedSeniorCitizen]);

  return (
    <>
      <div className="card-section-content container-fluid">
        {isLoading && (
          <div className="loading">
            <div className="spinner text-center">
              <span className="fas fa-1x fa-spin fa-spinner" />
            </div>
          </div>
        )}
        <div className="pt-3 px-3" style={{ fontSize: '24px' }}>
          <strong>
            {`${_.get(seniorCitizenInfo, 'attributes.first_name')} ${_.get(
              seniorCitizenInfo,
              'attributes.middle_name'
            )} ${_.get(seniorCitizenInfo, 'attributes.last_name')}` || '- -'}
          </strong>
        </div>
        <div className="right-section-content">
          {/* GRAY HIGHLIGHT */}
          <div className="row highlight d-flex align-items-center mx-3 py-3">
            <div className="col-12 px-0 mt-0 mb-1">
              {/* BORDER */}
              <div className="card border-primary">
                <div className="container-fluid py-1">
                  {/* Action buttons on top */}
                  <div className="d-flex ml-auto justify-content-end mb-3">
                    <div className="d-flex flex-row justify-content-center align-items-center mr-4" style={{ height: '40px'}}>
                      <label className="alert" style={{ marginBottom: '0'}} >
                        <b>Amount: </b>
                      </label>
                      <div className="alert alert-info" style={{ marginBottom: '0'}}>
                        {/* <input type="text" placeholder="0.00" onChange={handleOnCHange}/> */}
                        {_.get(seniorCitizenInfo, 'attributes.amount') || '- -'}
                      </div>
                    </div>

                    <button
                      type="button"
                      onClick={onApprove(seniorCitizenInfo)}
                      className="gen-btn btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold mr-2"
                    >
                      {isLoading ? (
                        <i className="fa fa-spin fa-spinner" />
                      ) : (
                        <>
                          Approve <i className="fas fa-check ml-1" />
                        </>
                      )}
                    </button>
                    {/* reject */}
                    <button
                      type="button"
                      onClick={onReject(seniorCitizenInfo)}
                      className="gen-btn btn btn-danger font-weight-bold"
                    >
                      {isLoading ? (
                        <i className="fa fa-spin fa-spinner" />
                      ) : (
                        <>
                          Reject <i className="fas fa-times ml-1" />
                        </>
                      )}
                    </button>
                  </div>
                  {/* Action buttons: end */}
                  <Tabs>
                    <TabList>
                      <Tab>Profile</Tab>
                    </TabList>
                    <TabPanel>
                      <ProfileInformation
                        seniorCitizenInfo={seniorCitizenInfo}
                      />
                    </TabPanel>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

SeniorCitizenContent.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
  // permissions: PropTypes.instanceOf(Object).isRequired,

  // transactionInfo: PropTypes.instanceOf(Object).isRequired,

  clearSeniorCitizen: PropTypes.instanceOf(Function).isRequired,
  seniorCitizenInfo: PropTypes.instanceOf(Object).isRequired,
  showSeniorCitizentList: PropTypes.instanceOf(Function).isRequired,

  approveTransaction: PropTypes.instanceOf(Function).isRequired,
  rejectTransaction: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  // permissions: getJson('permissions'),

  // transactionInfo: _.get(api, `${c.SHOW_INCIDENT}.item`) || {},

  seniorCitizenInfo: _.get(api, `${c.SHOW_SENIOR_CITIZEN}.item`) || {},
  isLoading: api.loading.indexOf(c.SHOW_SENIOR_CITIZEN) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, action)]);

export default enhance(SeniorCitizenContent);
